import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useSession from '../hooks/useSession';

function LogOut() {
   const navigate = useNavigate();
   const { clearSession } = useSession();

   useEffect(() => {
      clearSession();
      navigate('/', { replace: true });
   }, [clearSession, navigate])

   return null;
}

export default LogOut;